import { render } from "./onboarding_index.html?vue&type=template&id=043c672b&external"
import script from "./onboarding_index.js?vue&type=script&lang=js&external"
export * from "./onboarding_index.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__